import type { Grade } from "../enums/grade";
import type { ReferenceElement } from "../IDElement";
import type { ProbationConfiguration } from "../reportConfigs/probationConfiguration";
import type { Report } from "./report";

export type ProbationReport = Report & {
  report_configuration: ProbationConfiguration;
  data: {
    aspects: ReportAspect[];
    remarks: string;
    discussed_at: string;
  };
};

export type ReportAspect = ReferenceElement & {
  grade: Grade | null;
};

export const emptyReportAspect: ReportAspect = { grade: null, reference: "" };
